import EInvoiceServiceProxy from '@/store/proxies/e-invoice-service-proxy';
import ToastUtils from '@/utils/toast';

const internalTaxCode = '0315151651';

export default function onPreviewInvoice($event, invoice) {
  $event.preventDefault();
  $event.stopPropagation();


  if (invoice.secretCode) {
    if (invoice.tcgp_taxcode !== internalTaxCode) {
      this.$modal.show('external-invoice-modal', { model: { taxCode: invoice.tcgp_taxcode, secretCode: invoice.secretCode } });
      return;
    }
    new EInvoiceServiceProxy().searchEInvoiceService(invoice.secretCode)
      .then((res) => {
        if (res) {
          const props = {
            invoiceId: res.id,                          // Invoice id
            invoiceCommonCode: res.invoice_common_code, // Invoice Common code

            buyerInfo: res.buyer_obj,                   // Buyer object
            mailHistories: res.mail_histories,          // Lịch sử gửi mail

            pdfURL: res.signed_pdf,                     // URL of pdf file
            xmlURL: res.signed_xml,                     // URL of xml file
            zipURL: res.zip_resource_url,               // URL of zip file

            changedInvoiceData: {
              changeInvoices: res.change_invoices_fk,
              changedInvoice: res.changed_invoice_fk,
              currentInvoice: {
                status: invoice.invoice_type,
                invoice_number: invoice.invoice_number,
              },
            },
          };
          if (!props.pdfURL) {
            ToastUtils.showToast('error', this.$t('invoice.external-invoice.toast.dataFetchError'));
            return;
          }
          this.$modal.show('invoice-preview-modal', props);
        }
      })
      .catch((error) => {
        ToastUtils.showToast('error', error.message);
      });
  } else {
    const metadata = invoice.metadata;
    const [id, signed_pdf, signed_xml, invoice_common_code, change_invoices_fk, changed_invoice_fk, mail_histories] = metadata
      ? [metadata.id, metadata.signed_pdf, metadata.signed_xml, metadata.invoice_common_code, metadata.change_invoices_fk, metadata.changed_invoice_fk, metadata.mail_histories]
      : [null, null, null, null, null, null, null];
    const props = {
      invoiceId: id,                          // Invoice id
      invoiceCommonCode: invoice_common_code, // Invoice Common code

      pdfURL: signed_pdf,                     // URL of pdf file
      xmlURL: signed_xml,                     // URL of xml file
      mailHistories: mail_histories,          // Lịch sử gửi mail

      buyerInfo: {
        buyer_name: invoice.buyer_name,
        buyer_legal_name: invoice.buyer_legal_name,
        buyer_email: invoice.buyer_email,
      },

      changedInvoiceData: {
        changeInvoices: change_invoices_fk,
        changedInvoice: changed_invoice_fk,
        currentInvoice: {
          status: invoice.invoice_type,
          invoice_number: invoice.invoice_number,
        },
      },
    };
    if (!props.pdfURL) {
      ToastUtils.showToast('error', this.$t('invoice.external-invoice.toast.dataFetchError'));
      return;
    }
    this.$modal.show('invoice-preview-modal', props);
  }
}



// WEBPACK FOOTER //
// ./src/utils/invoice-preview.js